import { Modal } from '@design-system/components/modal/modal';
import { DropZone } from '@design-system/components/dropZone/dropZone';
import { UploadProgramModel } from '@client/new/pages/collections/uploadProgram.model';
import { Button } from '@design-system/components/button/button';
import Spinner from '@client/components/Spinner';
import { Typography } from '@design-system/components/typography/typography';

type ProgramUploadModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onDrop: (file: File) => void;
  onSubmit: () => void;
  data: Pick<UploadProgramModel, 'step' | 'uploadSummary'>;
};

export const ProgramUploadModal = ({
  isOpen,
  onClose,
  onDrop,
  onSubmit,
  data: { step, uploadSummary },
}: ProgramUploadModalProps) => {
  const hasErrors = Boolean(uploadSummary?.errors);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      modalClassName="w-[900px] overflow-hidden"
      modalContentClassName="gap-[39px] overflow-hidden"
    >
      <div className="flex flex-col gap-[39px]">
        {step === 'No File' && (
          <>
            {' '}
            <Typography variant="display" size="small">
              Upload Files
            </Typography>
            <DropZone
              onChange={(files: File[]) => onDrop(files[0])}
              accept={['application/json', 'text/csv']}
              className="h-[170px]"
            />
          </>
        )}

        {step === 'Uploading' && (
          <>
            <Typography variant="display" size="small">
              Processing
            </Typography>
            <Spinner
              size={100}
              color="black"
              duration={2500}
              style={{ 'margin-left': '40%' }}
            />
          </>
        )}

        {step === 'Transferred' && (
          <>
            <Typography variant="display" size="small">
              {hasErrors ? 'Error' : 'Create Program'}
            </Typography>
            {hasErrors ? (
              <>
                <Typography variant="body" size="large">
                  {uploadSummary.message}{' '}
                </Typography>
                {uploadSummary.errors.map((e, i) => (
                  <p key={`error-${i}`}>• {e}</p>
                ))}
              </>
            ) : (
              <Typography variant="body" size="large">
                <p>
                  {' '}
                  A program will be created: <b>{uploadSummary.program.name}</b>
                </p>
                <p>• {uploadSummary.program.weeks} weeks</p>
                <p>• {uploadSummary.program.workouts} workouts</p>
                <p>• {uploadSummary.program.exercises} exercises </p>
              </Typography>
            )}

            <div>
              <Button
                type="submit"
                className="float-right"
                color="neutral"
                onClick={onSubmit}
                disabled={hasErrors}
              >
                Create
              </Button>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};
